import { CustomNotification } from 'common/components';

import { useMutation, useIsMutating } from '@tanstack/react-query';
import { editUserOktaEmail } from 'services/user';

const EDIT_OKTA_EMAIL_KEY = ['user-profile', 'edit-okta-email-key'];

export const useEditOktaEmail = () => {
  const editOktaMutation = useMutation({
    mutationFn: editUserOktaEmail,
    mutationKey: EDIT_OKTA_EMAIL_KEY,
    onSuccess: (result) => {
      if (result?.isSuccess) {
        CustomNotification.success('Change OKTA email successfully.');
      } else {
        CustomNotification.error(result?.message || 'Something went wrong!');
      }
    },
    onError: () => {
      CustomNotification.error('Something went wrong!');
    },
  });
  const loading = useIsMutating({ mutationKey: EDIT_OKTA_EMAIL_KEY });
  return {
    editOktaMutation,
    loading,
  };
};
